module.exports = __webpack_public_path__ + "img/1(5)-230x230.97b45910.png";